'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "className", "contentClassName", "orientation"];
import PropTypes from 'prop-types';
import AbstractDeviceFrame from './AbstractDeviceFrame';
import { BATTLESHIP, GYPSUM } from 'HubStyleTokens/colors';
import classNames from 'classnames';

// Reduce by 115
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MobilePortraitFrame = props => /*#__PURE__*/_jsx("svg", Object.assign({}, props, {
  children: /*#__PURE__*/_jsxs("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M1 30.503v469.994C1 516.79 14.211 530 30.507 530h237.986C284.791 530 298 516.792 298 500.497V30.503C298 14.21 284.789 1 268.493 1H30.507C14.209 1 1 14.208 1 30.503zM286.5 37.5v455.503c0 14.082-11.414 25.497-25.496 25.497H37.996c-14.081 0-25.496-11.415-25.496-25.497V37.5h274z",
      stroke: BATTLESHIP,
      fill: GYPSUM
    }), /*#__PURE__*/_jsxs("g", {
      transform: "translate(120.5 20.5)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M14.716 2.464h42.638",
        stroke: BATTLESHIP,
        strokeWidth: "2",
        strokeLinecap: "round"
      }), /*#__PURE__*/_jsx("ellipse", {
        fill: BATTLESHIP,
        cx: "3.403",
        cy: "2.61",
        rx: "2.597",
        ry: "2.61"
      })]
    })]
  })
}));
const MobileLandscapeFrame = props => /*#__PURE__*/_jsx("svg", Object.assign({}, props, {
  children: /*#__PURE__*/_jsxs("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M30.503 298h469.994C516.79 298 530 284.789 530 268.493V30.507C530 14.209 516.792 1 500.497 1H30.503C14.21 1 1 14.211 1 30.507v237.986C1 284.791 14.208 298 30.503 298zM37.5 12.5h455.503c14.082 0 25.497 11.414 25.497 25.496v223.008c0 14.081-11.415 25.496-25.497 25.496H37.5v-274z",
      stroke: BATTLESHIP,
      fill: GYPSUM
    }), /*#__PURE__*/_jsxs("g", {
      transform: "rotate(-90 99.5 79)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M14.716 2.464h42.638",
        stroke: BATTLESHIP,
        strokeWidth: "2",
        strokeLinecap: "round"
      }), /*#__PURE__*/_jsx("ellipse", {
        fill: BATTLESHIP,
        cx: "3.403",
        cy: "2.61",
        rx: "2.597",
        ry: "2.61"
      })]
    })]
  })
}));
const MOBILE_DEVICE_SPECS = {
  mobilePortrait: {
    Template: MobilePortraitFrame,
    top: 37.5,
    right: 12.5,
    bottom: 12.5,
    left: 12.5,
    height: 531,
    width: 299
  },
  mobileLandscape: {
    Template: MobileLandscapeFrame,
    top: 12.5,
    right: 12.5,
    bottom: 12.5,
    left: 37.5,
    height: 299,
    width: 531
  }
};
const UIDeviceFrameMobile = props => {
  const {
      children,
      className,
      contentClassName,
      orientation
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const computedSpecs = orientation === 'landscape' ? MOBILE_DEVICE_SPECS.mobileLandscape : MOBILE_DEVICE_SPECS.mobilePortrait;
  return /*#__PURE__*/_jsx(AbstractDeviceFrame, Object.assign({}, rest, {
    className: classNames(className, 'UIDeviceFrameMobile'),
    contentClassName: contentClassName,
    spec: computedSpecs,
    orientation: orientation,
    children: children
  }));
};
UIDeviceFrameMobile.propTypes = {
  children: PropTypes.node.isRequired,
  contentClassName: PropTypes.string,
  orientation: PropTypes.oneOf(['portrait', 'landscape'])
};
UIDeviceFrameMobile.defaultProps = {
  orientation: 'portrait'
};
UIDeviceFrameMobile.displayName = 'UIDeviceFrameMobile';
export default UIDeviceFrameMobile;